/* eslint-disable @typescript-eslint/no-explicit-any */
import { useDispatch } from "react-redux";
import { setTermValidationFilter } from "../index";

export const useTermValidationFilterActions = () => {
  const dispatch = useDispatch();

  const updateFilter: any = ({ key, value }: { key: string; value: any }) => {
    dispatch(setTermValidationFilter({ key, value }));
  };

  return { updateFilter };
};